import { getDayNumberSinceDateInSydney } from '@duke-hq/lib';

export function calculateDayNumber(enrolmentCreatedAt: Date, currentDate: Date): number {
  return getDayNumberSinceDateInSydney(enrolmentCreatedAt, currentDate);
}
